"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarOverlay = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const avatar_overlay_style_1 = __importDefault(require("./avatar.overlay.style"));
class AvatarOverlay extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, icon } = this.props;
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.icon }, { children: icon }), void 0) }), void 0));
        };
    }
}
exports.AvatarOverlay = AvatarOverlay;
AvatarOverlay.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    icon: prop_types_1.default.node.isRequired
};
exports.default = react_jss_1.default(avatar_overlay_style_1.default)(AvatarOverlay);
//# sourceMappingURL=avatar.overlay.js.map